import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum CZEPurposeOfStayId {
  MEDICAL = 1,
  BUSINESS = 2,
  CULTURAL = 3,
  FAMILY_VISIT = 4,
  INVITATION = 5,
  OFFICIAL = 6,
  SELF_EMPLOYMENT = 7,
  SPORT = 8,
  LEISURE = 9,
  STUDY = 10,
  TRANSIT = 11,
  AIRPORT_TRANSIT = 12,
  EMPLOYMENT = 13,
  ADS_VISUM = 14,
  OTHER = 15,
}

export class CZEPurposeOfStay extends Codebook<CZEPurposeOfStayId> {
  private constructor(
    public readonly id: CZEPurposeOfStayId,
    public readonly name: () => string,
    public readonly code: string,
  ) {
    super(id)
  }

  static readonly MEDICAL = new CZEPurposeOfStay(
    CZEPurposeOfStayId.MEDICAL,
    () => $t('Medical'),
    '00',
  )
  static readonly BUSINESS = new CZEPurposeOfStay(
    CZEPurposeOfStayId.BUSINESS,
    () => $t('Business trip'),
    '01',
  )
  static readonly CULTURAL = new CZEPurposeOfStay(
    CZEPurposeOfStayId.CULTURAL,
    () => $t('Cultural'),
    '02',
  )
  static readonly FAMILY_VISIT = new CZEPurposeOfStay(
    CZEPurposeOfStayId.FAMILY_VISIT,
    () => $t('Family visit'),
    '03',
  )
  static readonly INVITATION = new CZEPurposeOfStay(
    CZEPurposeOfStayId.INVITATION,
    () => $t('Invitation'),
    '04',
  )
  static readonly OFFICIAL = new CZEPurposeOfStay(
    CZEPurposeOfStayId.OFFICIAL,
    () => $t('Official (political)'),
    '05',
  )
  static readonly SELF_EMPLOYMENT = new CZEPurposeOfStay(
    CZEPurposeOfStayId.SELF_EMPLOYMENT,
    () => $t('Business - Self employed'),
    '06',
  )
  static readonly SPORT = new CZEPurposeOfStay(CZEPurposeOfStayId.SPORT, () => $t('Sport'), '07')
  static readonly LEISURE = new CZEPurposeOfStay(
    CZEPurposeOfStayId.LEISURE,
    () => $t('Leisure'),
    '10',
  )
  static readonly STUDY = new CZEPurposeOfStay(
    CZEPurposeOfStayId.STUDY,
    () => $t('Study (training, internship)'),
    '11',
  )
  static readonly TRANSIT = new CZEPurposeOfStay(
    CZEPurposeOfStayId.TRANSIT,
    () => $t('Transit'),
    '12',
  )
  static readonly AIRPORT_TRANSIT = new CZEPurposeOfStay(
    CZEPurposeOfStayId.AIRPORT_TRANSIT,
    () => $t('Airport transit'),
    '13',
  )
  static readonly EMPLOYMENT = new CZEPurposeOfStay(
    CZEPurposeOfStayId.EMPLOYMENT,
    () => $t('Employment'),
    '27',
  )
  static readonly ADS_VISUM = new CZEPurposeOfStay(
    CZEPurposeOfStayId.ADS_VISUM,
    () => $t('ADS visa for citizens of China ...'),
    '93',
  )
  static readonly OTHER = new CZEPurposeOfStay(
    CZEPurposeOfStayId.OTHER,
    () => $t('Other / Different'),
    '99',
  )
}
